// import { Controller } from "@hotwired/stimulus"

// export default class extends Controller {
//   static targets = ["organizations", "departments"]

//   connect() {
//     if (this.organizationsTarget.value) {
//       this.updateDepartments()
//     }
//   }

//   async updateDepartments() {
//     console.log("updating departmetns...")
//     const selectedOrganizationIds = Array.from(this.organizationsTarget.selectedOptions).map(option => option.value)
//     const currentDepartmentIds = Array.from(this.departmentsTarget.selectedOptions).map(option => option.value)
    
//     if (selectedOrganizationIds.length === 0) {
//       this.departmentsTarget.innerHTML = '<option value="" disabled selected>Select organization(s) first</option>'
//       return
//     }

//     try {
//       const response = await fetch(`/departments/options?organization_ids=${selectedOrganizationIds.join(',')}&selected_ids=${currentDepartmentIds.join(',')}`)
//       const html = await response.text()
//       this.departmentsTarget.innerHTML = html
//     } catch (error) {
//       console.error('Error fetching departments:', error)
//     }
//   }
// } 

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["organizations", "departments"]
  
  connect() {
    this.initializeSelect2()
    if (this.organizationsTarget.value) {
      this.updateDepartments()
    }
  }

  initializeSelect2() {
    // Initialize Select2 on both selects
    $(this.organizationsTarget).select2()
    $(this.departmentsTarget).select2()

    // Add event listener for Select2 change event
    $(this.organizationsTarget).on('change', () => this.updateDepartments())
  }

  async updateDepartments() {
    const selectedOrganizationIds = Array.from(this.organizationsTarget.selectedOptions).map(option => option.value)
    const currentDepartmentIds = Array.from(this.departmentsTarget.selectedOptions).map(option => option.value)
    
    if (selectedOrganizationIds.length === 0) {
      this.departmentsTarget.innerHTML = '<option value="" disabled selected>Select organization(s) first</option>'
      $(this.departmentsTarget).trigger('change') // Trigger Select2 update
      return
    }

    try {
      const response = await fetch(`/departments/options?organization_ids=${selectedOrganizationIds.join(',')}&selected_ids=${currentDepartmentIds.join(',')}`)
      const html = await response.text()
      this.departmentsTarget.innerHTML = html
      $(this.departmentsTarget).trigger('change') // Trigger Select2 update
    } catch (error) {
      console.error('Error fetching departments:', error)
    }
  }

  disconnect() {
    // Clean up Select2 when the controller is disconnected
    $(this.organizationsTarget).select2('destroy')
    $(this.departmentsTarget).select2('destroy')
  }
}